module.exports = __webpack_public_path__ + "img/inventory_delete.37d41b9a.svg";